import type { ReactNode } from 'react';

export const symbol_battery_android_frame_shield: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M130-240q-38 0-64-26t-26-64v-300q0-38 26-64t64-26h435q13 0 21.5 8.5T595-690q0 13-8.5 21.5T565-660H130q-13 0-21.5 8.5T100-630v300q0 13 8.5 21.5T130-300h473q14 0 22 9.5t8 20.5q0 11-7.5 20.5T603-240H130Zm30-90q-13 0-21.5-8.5T130-360v-240q0-13 8.5-21.5T160-630h318q10 0 16.5 7t7.5 17q5 66 21 127.5T568-364q7 11 1 22.5T550-330H160Zm567.5 43.5Q721-288 716-291q-65-35-108.5-115.5T560-583q0-8 4.5-12.5T577-601q29-4 64-20t81-47q8-5 18-5t18 5q46 31 81 47t64 20q7 1 12 6t5 12q-4 96-47.5 176.5T764-291q-5 3-11.5 4.5T740-285q-6 0-12.5-1.5ZM740-346q45-25 76-80.5T857-550q-26-8-54.5-22.5T740-608v262Z"
		/>
	</svg>
);
